(ns practitest.frontend.components.test-type
  (:require [reagent.core :as reagent]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.components.icons :as icons]
            [clojure.string :as str]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.common.dom :as dom]))

(def types-map
  {"ScriptedTest"    {:title "Scripted Test"
                      :icon  icons/scripted-test}
   "ExploratoryTest" {:title "Exploratory Test"
                      :icon  icons/exploratory-test}
   "xBotTest"        {:title "xBot Test"
                      :icon  icons/xbot-test}
   "FirecrackerTest" {:title "Firecracker Test"
                      :icon  icons/firecracker-test}
   "ApiTest"         {:title "API Test"
                      :icon  icons/api-test}
   "BDDTest"         {:title "BDD Test"
                      :icon  icons/bdd-test}})

(defn get-type-label
  [status]
  (:title (get types-map status)))

(defn get-type-icon
  [status]
  (when-let [icon (:icon (get types-map status))]
    [icon]))

(defn type-label
  [type]
  [tooltip/hover-tooltip
   [:<>
    [:span.me-2 (get-type-icon type)]
    (get-type-label type)]
   (get-type-icon type)])
